import {useMemo} from 'react';
import {SVG} from '../../../../../constants/assetLists';
import {useTranslation} from 'react-i18next';
import {useOperationsContext} from '../../../../../context/OperationsContextProvider';
import AppButton from '../../../../../components/common/AppButton';
import useScreenSize from '../../../../../hooks/useScreenSize';

type Props = {
  open: boolean;
  onClose: () => void;
};

function AnnouncementFilter({open, onClose}: Props) {
  const {i18n} = useTranslation();
  const isHebrew = useMemo(() => i18n.language === 'heb', [i18n.language]);

  const {filterSidebarVariant, compactSidebarWidth} = useOperationsContext();
  const screenSize = useScreenSize();
  const isLarge = screenSize == 'xl' || screenSize == '2xl';

  return open ? (
    <div
      className="absolute mt-2 z-[1] border border-gray50 shadow-lg bg-white"
      style={
        isLarge
          ? filterSidebarVariant === 'full'
            ? isHebrew
              ? {right: '209px', left: 0}
              : {left: '209px', right: 0}
            : filterSidebarVariant === 'compact'
            ? isHebrew
              ? {right: `${compactSidebarWidth}`, left: 0}
              : {left: '66px', right: 0}
            : isHebrew
            ? {right: '24px', left: 0}
            : {left: '24px', right: 0}
          : {right: 0, left: 0}
      }>
      <div className={`w-full h-full px-4 py-3 flex flex-col gap-3`}>
        <div className="flex justify-between items-center gap-2">
          <p className="m-0 text-[20px] font-medium text-black">סינון מתקדם</p>

          <button
            className="w-[14px] h-[14px] hover:opacity-40"
            onClick={onClose}>
            <img
              src={SVG.closeGrayIcon}
              alt="close"
              className="w-full h-full object-contain"
            />
          </button>
        </div>

        <h6>TBD</h6>
        <h6>TBD</h6>

        <div className="w-full flex justify-end">
          <AppButton className="border-2">סינון</AppButton>
        </div>
      </div>
    </div>
  ) : null;
}

export default AnnouncementFilter;
